export const followUpActionTranslations = {
    en: {
        // Page Title
        followUpsIn: "Follow Ups In",
        selectCamp: "Select Camp",

        // Autocomplete
        selectVisitedCamp: "Select Visited Health Camp",
        unknown: "Unknown",
        unknownAddress: "Unknown Address"
    },
    mr: {
        // Page Title
        followUpsIn: "यामध्ये फॉलो अप",
        selectCamp: "शिबिर निवडा",

        // Autocomplete
        selectVisitedCamp: "भेट दिलेले आरोग्य शिबिर निवडा",
        unknown: "अज्ञात",
        unknownAddress: "अज्ञात पत्ता"
    }
};
